class Popup {
  public items: NodeListOf<HTMLElement> | null;
  public selectorClass: string = 'popup';
  public config: Object = {};
  public possibleSizes: Array<string> = ['size-medium', 'size-large', 'size-large--py-0', 'size-full'];

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item: any) => {

        item.addEventListener('click', (e: Event) => {
          const target = e.currentTarget as HTMLElement;
          if (target) {
            this.onTrigger(target.dataset);
          }
        });
      });

      // Close popup on click outside
      document.querySelectorAll('.m-popup').forEach((element) => {
        element.addEventListener('click', (e: Event) => {
          // @ts-ignore
          if (this.config.clickOnClose == false) {
            return;
          }
          // @ts-ignore
          if (e.target?.classList.contains("m-popup") && e.target == e.target?.closest(".m-popup")) {
            element.classList.remove('m-popup--is-active');
            element.classList.remove('success');
            document.body.classList.remove('m-popup--is-visible');
            document.body.classList.remove('roomle-is-open');
            window.dispatchEvent(new Event('popup:close'));
          }
          if((element as HTMLElement).dataset.key === 'registration-success') {
            window.scrollTo({top: 0});
            window.location.reload();
          }
        });
      });
    }
  }

  onTrigger(config: any) {
    this.config = config;

    const targetedModal = config.target;
    if (targetedModal) {
      document.body.classList.toggle('m-popup--is-visible');
      const modal = document.getElementById(targetedModal);

      if (modal) {

        if (config.form) {
          // @ts-ignore
          modal.dataset.key = config.form;
        }

        if (modal.classList.contains('m-popup--is-active') == false) {
          // Remove all old sizes
          this.possibleSizes.forEach((size: string) => {
            modal.classList.remove(size);
          });

          // Set new size
          let modalSize = 'medium';
          if (config.size) {
            modalSize = config.size;
          }
          modal.classList.add('size-' + modalSize);
        } else {
          document.body.classList.remove('roomle-is-open');
          window.dispatchEvent(new Event('popup:close'));
        }
        modal.classList.toggle('m-popup--is-active');
        modal.classList.remove('success');
        if (this.selectorClass == 'search-popup' && modal.classList.contains('m-popup--is-active')) {
          modal.querySelector('input')?.focus();
        }
        document.addEventListener(
          'keydown',
          (e: KeyboardEvent) => {
            this.handleKeyboardClose(modal, e);
          },
          { once: true }
        );
      }
    }
  }

  cache() {
    this.items = document.querySelectorAll('[data-toggle="' + this.selectorClass + '"]');
  }

  handleKeyboardClose(modal: HTMLElement, e: KeyboardEvent) {
    if ((e && e.code === 'Escape') || !e) {
      modal.classList.remove('m-popup--is-active');
      modal.classList.remove('success');
      document.body.classList.toggle('m-popup--is-visible');
      document.body.classList.remove('roomle-is-open');
      window.dispatchEvent(new Event('popup:close'));
      if(modal.dataset.key === 'registration-success') {
        window.scrollTo({top: 0});
        window.location.reload();
      }
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Popup;
